import React, { useState } from 'react';
import { ArrowLeft, Send } from 'lucide-react';
import { Link } from 'react-router-dom';
import { sendEmail } from '../services/emailService';

const UpcomingBooks = () => {
  const [formData, setFormData] = useState({
    name: '',
    designation: '',
    paperTitle: '',
    whatsapp: '',
    mobile: '',
    email: ''
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const result = await sendEmail(formData, 'upcoming');
    
    if (result.success) {
      alert(result.message);
      setFormData({ name: '', designation: '', paperTitle: '', whatsapp: '', mobile: '', email: '' });
    } else {
      alert(result.message);
    }
  };

  const upcomingBooks = [
    {
      bookName: "Future of Education 2025",
      editor: "Dr. Anand Kumar",
      category: "Education",
      isbn: "978-93-90781-15-7"
    },
    {
      bookName: "Artificial Intelligence in Research",
      editor: "Prof. Lakshmi Iyer",
      category: "Technology",
      isbn: "978-93-90781-16-4"
    },
    {
      bookName: "Sustainable Development Goals",
      editor: "Dr. Vinod Mehta",
      category: "Environment",
      isbn: "978-93-90781-17-1"
    }
  ];

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh', padding: '80px 0' }}>
      <div className="container-custom">
        <Link to="/books" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: '#667eea', textDecoration: 'none', marginBottom: '30px', fontWeight: '600' }}>
          <ArrowLeft size={20} />
          <span>Back to Books</span>
        </Link>

        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <div style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              padding: '12px 30px',
              borderRadius: '25px',
              fontSize: '1rem',
              fontWeight: 'bold',
              marginBottom: '20px'
            }}>
              🚀 UPCOMING OPPORTUNITIES
            </div>
            <h1 style={{ color: '#2d3748', fontSize: '3rem', fontWeight: 700, marginBottom: '20px' }}>Upcoming Book Chapters</h1>
            <p style={{ color: '#718096', fontSize: '1.2rem', maxWidth: '600px', margin: '0 auto' }}>
              Submit your research papers and book chapters for our upcoming publications
            </p>
          </div>

          {/* Book Opportunities */}
          <div style={{ display: 'grid', gap: '30px', marginBottom: '60px' }}>
            {upcomingBooks.map((book, index) => (
              <div key={index} style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '3px',
                borderRadius: '20px',
                boxShadow: '0 8px 32px rgba(102, 126, 234, 0.2)'
              }}>
                <div style={{
                  backgroundColor: 'white',
                  padding: '40px',
                  borderRadius: '17px'
                }}>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '30px' }}>
                    <div>
                      <h4 style={{ color: '#667eea', fontSize: '0.9rem', fontWeight: 600, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>📚 BOOK NAME</h4>
                      <p style={{ color: '#2d3748', fontWeight: 700, fontSize: '1.2rem' }}>{book.bookName}</p>
                    </div>
                    <div>
                      <h4 style={{ color: '#667eea', fontSize: '0.9rem', fontWeight: 600, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>👨🏫 EDITOR</h4>
                      <p style={{ color: '#2d3748', fontWeight: 700, fontSize: '1.2rem' }}>{book.editor}</p>
                    </div>
                    <div>
                      <h4 style={{ color: '#667eea', fontSize: '0.9rem', fontWeight: 600, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>🏷️ CATEGORY</h4>
                      <p style={{ color: '#2d3748', fontWeight: 700, fontSize: '1.2rem' }}>{book.category}</p>
                    </div>
                    <div>
                      <h4 style={{ color: '#667eea', fontSize: '0.9rem', fontWeight: 600, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>📋 ISBN</h4>
                      <p style={{ color: '#718096', fontWeight: 600, fontSize: '1.1rem', fontFamily: 'monospace' }}>{book.isbn}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Submission Form */}
          <div style={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
            padding: '3px', 
            borderRadius: '20px', 
            boxShadow: '0 8px 32px rgba(102, 126, 234, 0.3)' 
          }}>
            <div style={{ 
              backgroundColor: 'white', 
              padding: '50px', 
              borderRadius: '17px'
            }}>
              <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                <div style={{
                  display: 'inline-block',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  padding: '12px 30px',
                  borderRadius: '25px',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  marginBottom: '15px'
                }}>
                  📝 CHAPTER SUBMISSION
                </div>
                <h3 style={{ color: '#2d3748', fontSize: '2rem', fontWeight: 700, margin: 0 }}>Submit Your Chapter</h3>
                <p style={{ color: '#718096', fontSize: '1.1rem', marginTop: '10px' }}>Join thousands of researchers worldwide</p>
              </div>
              
              <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '25px' }}>
                <div>
                  <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>👤 Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '15px 20px',
                      backgroundColor: '#f7fafc',
                      border: '2px solid #e2e8f0',
                      borderRadius: '12px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      outline: 'none'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>🎓 Designation *</label>
                  <input
                    type="text"
                    name="designation"
                    value={formData.designation}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '15px 20px',
                      backgroundColor: '#f7fafc',
                      border: '2px solid #e2e8f0',
                      borderRadius: '12px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      outline: 'none'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  />
                </div>

                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>📄 Paper Title *</label>
                  <input
                    type="text"
                    name="paperTitle"
                    value={formData.paperTitle}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '15px 20px',
                      backgroundColor: '#f7fafc',
                      border: '2px solid #e2e8f0',
                      borderRadius: '12px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      outline: 'none'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>💬 WhatsApp Number *</label>
                  <input
                    type="tel"
                    name="whatsapp"
                    value={formData.whatsapp}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '15px 20px',
                      backgroundColor: '#f7fafc',
                      border: '2px solid #e2e8f0',
                      borderRadius: '12px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      outline: 'none'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>📱 Mobile Number *</label>
                  <input
                    type="tel"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '15px 20px',
                      backgroundColor: '#f7fafc',
                      border: '2px solid #e2e8f0',
                      borderRadius: '12px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      outline: 'none'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  />
                </div>

                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>📧 Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '15px 20px',
                      backgroundColor: '#f7fafc',
                      border: '2px solid #e2e8f0',
                      borderRadius: '12px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      outline: 'none'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  />
                </div>

                <div style={{ gridColumn: '1 / -1', textAlign: 'center', marginTop: '30px' }}>
                  <button type="submit" style={{
                    padding: '18px 50px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '30px',
                    fontSize: '1.1rem',
                    fontWeight: 700,
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '12px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.6)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
                  }}>
                    <Send size={20} />
                    Submit Chapter
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpcomingBooks;